import { Fragment } from "react";

import { Button } from "@mui/material";

import { GridItem, GridRow } from "commons/ui/Grid";

import WorkOfferForm from "components/form/WorkOfferForm";

import { SaveContextProvider } from "context/save";

import useSaveUpdateWithSnackbar from "hooks/useSaveUpdateWithSnackbar";

function ButtonSave() {
    const { onButtonClick } = useSaveUpdateWithSnackbar({
        successMsg: "Offerta creata con successo",
        errorMsg: "Errore nella creazione dell'offerta",
        navigateTo: { link: "/lavora-con-noi" },
    });

    return (
        <GridRow justifyContent={"right"}>
            <GridItem className={"button-under-paper"}>
                <Button variant={"contained"} onClick={onButtonClick}>
                    Salva
                </Button>
            </GridItem>
        </GridRow>
    );
}

function NuovaOfferta() {
    return (
        <Fragment>
            <GridRow className={"title-top-paper"}>
                <GridItem>
                    <h1>Aggiungi Offerta</h1>
                </GridItem>
            </GridRow>

            <SaveContextProvider>
                <WorkOfferForm />

                <ButtonSave />
            </SaveContextProvider>
        </Fragment>
    );
}

export default NuovaOfferta;
